import { render, staticRenderFns } from "./ConfigurarNotificacionForm.vue?vue&type=template&id=39e71ec6&"
import script from "./ConfigurarNotificacionForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarNotificacionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('39e71ec6', component.options)
    } else {
      api.reload('39e71ec6', component.options)
    }
    module.hot.accept("./ConfigurarNotificacionForm.vue?vue&type=template&id=39e71ec6&", function () {
      api.rerender('39e71ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Alertas/ConfigurarNotificacionForm.vue"
export default component.exports